import { useDispatch, useSelector } from "react-redux";
import { Step, IStore } from "../DataTypes/storeTypes";
import { cancel, requestCancel } from "../Actions/actions";
import { StepsPanel } from "./Steps/StepsPanel";
import { ConfirmedInfo } from "./ConfirmedInfo";
import { IConfirmationProps, ConfirmationDialog } from "../../Modals/Confirmation";
import { Navigation } from "./Summary/Navigation";
import { StepsSummary } from "./Summary/StepsSummary";

export const MainPanel = () => {
    const {
        common: { bookedAppointment, cancelRequested, currentStep },
    } = useSelector((state: IStore) => state);
    const dispatch = useDispatch();

    const cancelSettings: IConfirmationProps = {
        yesButtonCallback: () => dispatch(cancel()),
        noButtonCallback: () => dispatch(requestCancel(false)),
        onModalClosed: () => dispatch(requestCancel(false)),
        text: "Are you sure you want to cancel?",
    };

    const isConfirmation = currentStep === Step.Confirmation;
    const stepsClass = isConfirmation ? `col-11 ml-auto mr-auto` : `col-lg-8 col-12`;

    return (
        <div>
            {!bookedAppointment && (
                <div className="row">
                    <div className={`${stepsClass} fit-height-scroll`}>
                        <StepsPanel />
                    </div>

                    {!isConfirmation && (
                        <div className="col-lg-4 col-12 summary-sidebar">
                            <Navigation />
                            <StepsSummary />
                        </div>
                    )}
                </div>
            )}
            {bookedAppointment && (
                <div className="row">
                    <div className="col-11 ml-auto mr-auto">
                        <ConfirmedInfo />
                    </div>
                </div>
            )}

            {cancelRequested && <ConfirmationDialog {...cancelSettings} />}
        </div>
    );
};
